<template>
    <div class="content">
        <el-row class="bgW">
            <el-col :span="22">
                <el-form class="search" :inline="true" size="mini" :model="search">
                    <el-form-item label="时间">
                        <el-select v-model="search.action" class="w100">
                            <el-option
                                v-for="item in options.time_type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-date-picker
                            v-model="search.start"
                            type="date"
                            class="w130"
                            placeholder="开始日期"
                            value-format="yyyy-MM-dd"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="search.end"
                            type="date"
                            class="w130"
                            placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item>
                    
                    <el-form-item label="手机号">
                        
                        <el-input v-model="search.telephone" clearable placeholder="请输入用户手机号" class="w120" />
                    </el-form-item>
                    
                    <el-form-item label="门店/门诊" v-if="!userInfo.shop_id">
                        <el-select
                            v-model="search.shop_name"
                            clearable
                            remote
                            filterable
                            :remote-method="remoteMethod"
                            placeholder="请输入"
                            class="w120"
                        >
                            <el-option
                                v-for="item in options.shop_list"
                                :key="item.shopId"
                                :label="item.shopName"
                                :value="item.shopName"
                            />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="反馈类型">
                        <el-select v-model="search.type" clearable class="w120">
                            <el-option
                                v-for="item in options.type"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="状态">
                        <el-select v-model="search.status" clearable class="w120">
                            <el-option
                                v-for="item in options.statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-col>
            
            <el-col :span="2" style="text-align: right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
            </el-col>
        </el-row>
  
        <div class="accountCon">
            <div class="btnBox">
                <el-button
                    type="primary"
                    class="mb10"
                    size="mini"
                    v-if="!userInfo.shop_id"
                    @click="exportData"
                >导出数据</el-button>
            </div>
            
            <el-row>
                <el-col :span="24">
                    <el-table
                        :data="list"
                        size="small"
                        border
                        :cell-style="$style.cellStyle"
                        :header-cell-style="$style.rowClass"
                        @selection-change="handleSelectionChange"
                    >
                        <ElTableColumn label="序号" type="index" width="55" />
                        <el-table-column label="反馈时间" width="180" prop="create_time" />
                        <el-table-column label="反馈类型" width="80" prop="name" />
                        <el-table-column label="门店/门诊" prop="shop_name"/>
                        <el-table-column label="姓名" prop="customer_name" width="150" />
                        <el-table-column label="手机" width="100" prop="telephone" />
                        <el-table-column label="性别" prop="sex"/>
                        <el-table-column label="护理师" prop="nurse_name"/>

                        <el-table-column label="反馈内容" prop="feedback_content" width="240" />
                        <el-table-column label="反馈图片" >
                            <template slot-scope="scope">
                                <div class="image-container" v-if="scope.row.feedback_img && scope.row.feedback_img.length">
                                    <el-image 
                                        v-for="(img, index) in scope.row.feedback_img"
                                        :key="index"
                                        :src="img" 
                                        :preview-src-list="scope.row.feedback_img"
                                        style="width: 30px; height: 30px; cursor: pointer; margin-right: 5px"
                                        fit="cover"
                                    ></el-image>
                                </div>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否处理" width="80" prop="status">
                            <template slot-scope="scope">
                                <span :class="scope.row.status === '处理中' ? 'processing' : 'resolved'">
                                    {{ scope.row.status === '处理中' ? '待处理' : '已处理' }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="回复内容" width="140" prop="reply_content" />
                        <el-table-column label="回复员工" width="140" prop="reply_name" />
                        <el-table-column label="回复时间"  width="140" prop="reply_time">
                            <template slot-scope="scope">{{ scope.row.reply_time || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="回复图片">
                            <template slot-scope="scope">
                                <div class="image-container" v-if="scope.row.reply_img && scope.row.reply_img.length">
                                    <el-image 
                                        v-for="(img, index) in scope.row.reply_img"
                                        :key="index"
                                        :src="img" 
                                        :preview-src-list="scope.row.reply_img"
                                        style="width: 30px; height: 30px; cursor: pointer; margin-right: 5px"
                                        fit="cover"
                                    ></el-image>
                                </div>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right"  width="140">
                            <template slot-scope="{ row }">
                                <span class="theme" @click="handleFeedback(row)">
                                    {{ row.status === '处理中' ? '去处理' : '查看' }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination
                        class="page tc mt10"
                        :total="page.total"
                        :page.sync="page.page"
                        :limit.sync="page.limit"
                        @pagination="getList"
                    />
                </el-col>
            </el-row>
        </div>

        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <div class="feedback-detail">
                <div class="feedback-item">
                    <span class="label">反馈类型：</span>
                    <span>{{ currentFeedback.name || '-' }}</span>
                </div>
                <div class="feedback-item">
                    <span class="label">反馈内容：</span>
                    <span>{{ currentFeedback.feedback_content || '-' }}</span>
                </div>
                <div class="feedback-item">
                    <span class="label">提交时间：</span>
                    <span>{{ currentFeedback.create_time || '-' }}</span>
                </div>
                <div class="feedback-item">
                    <span class="label">反馈图片：</span>
                    <div class="image-group">
                        <el-image 
                            v-for="(img, index) in currentFeedback.feedback_img"
                            :key="index"
                            :src="img" 
                            :preview-src-list="currentFeedback.feedback_img"
                            style="width: 80px; height: 80px; margin-right: 10px; cursor: pointer"
                            fit="cover">
                        </el-image>
                        <span v-if="!currentFeedback.feedback_img || currentFeedback.feedback_img.length === 0">-</span>
                    </div>
                </div>
                
                <el-form 
                    v-if="isProcessing" 
                    :model="replyForm" 
                    ref="replyForm"
                    label-width="80px"
                >
                    <el-form-item 
                        label="回复内容" 
                        prop="reply_content"
                        class="w400"
                        :rules="[{ required: true, message: '请输入回复内容', trigger: 'blur' }]"
                    >
                        <el-input 
                            v-model="replyForm.reply_content" 
                            type="textarea" 
                            rows="4" 
                            placeholder="请输入回复内容"
                        ></el-input>
                    </el-form-item>
                    
                    <el-form-item 
                        label="反馈状态" 
                        prop="status"
                        :rules="[{ required: true, message: '请选择反馈状态', trigger: 'blur' }]"
                    >
                       <el-select v-model="replyForm.status" clearable class="w120">
                            <el-option
                                v-for="item in options.statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="回复配图">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl" 
                            :on-success="handleImageUploadSuccess"
                            :file-list="replyImageList"
                            :on-remove="handleImageRemove"
                            list-type="picture-card"
                            :on-exceed="handleImageExceed"
                            :before-upload="beforeUpload"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                            :visible.sync="dialogVisibleImg"
                            width="800px"
                            append-to-body
                        >
                            <img width="100%" :src="dialogImageUrl" alt="图片预览" />
                        </el-dialog>
                    </el-form-item>
                </el-form>
                
                <div v-else class="resolved-content">
                    <div class="feedback-item">
                        <span class="label">回复内容：</span>
                        <span>{{ currentFeedback.reply_content || '-' }}</span>
                    </div>
                    
                    <div class="feedback-item">
                        <span class="label">回复图片：</span>
                        <div class="image-group">
                            <el-image 
                                v-for="(img, index) in currentFeedback.reply_img"
                                :key="index"
                                :src="img" 
                                :preview-src-list="currentFeedback.reply_img"
                                style="width: 80px; height: 80px; margin-right: 10px; cursor: pointer"
                                fit="cover">
                            </el-image>
                            <span v-if="!currentFeedback.reply_img || currentFeedback.reply_img.length === 0">-</span>
                        </div>
                    </div>
                    
                    <div class="feedback-item">
                        <span class="label">回复时间：</span>
                        <span>{{ currentFeedback.reply_time || '-' }}</span>
                    </div>
                    
                    <div class="feedback-item">
                        <span class="label">回复客服：</span>
                        <span>{{ currentFeedback.reply_name || '-' }}</span>
                    </div>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
                <el-button 
                    type="primary" 
                    @click="submitReply" 
                    v-if="isProcessing"
                >
                    提交回复
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import { ssettingList } from "@/api/client";
import { getShopList } from "@/api/shop";
import { getFeedbackList, updateFeedback } from "@/api/sys";

export default {
    name: "FeedbackManagement",
    components: {
        pagination
    },
    data() {
        return {
            uploadUrl: 'https://sunburn.178590.com/mini/file/bannerFile',
            replyImageList: [],
            dialogVisibleImg: false,
            dialogImageUrl: "",
            search: {
                start: "",              // 开始时间
                end: "",                // 结束时间
                shop_name: "",          // 店铺名称
                type: "",               // 反馈类型
                action: "create_time",             // 时间类型（create_time/reply_time）
                telephone: "",          // 用户手机号
                status: ""              // 状态（处理中/已处理）
            },
            
            options: {
                shop_list: [],          // 店铺列表
                type: [],               // 反馈类型列表
                statusList: [
                    { label: "待处理", value: 1 },
                    { label: "已处理", value: 2 }
                ],
                time_type: [
                    { label: "反馈时间", value: "create_time" },
                    { label: "回复时间", value: "reply_time" }
                ]
            },
            
            page: {
                total: 0,               // 总条数
                page: 1,                // 当前页
                limit: 10               // 每页条数
            },
            
            list: [],
            idList: "",
            
            dialogVisible: false,
            dialogTitle: "",
            currentFeedback: {},
            
            replyForm: {
                id: "",        // 反馈ID
                reply_content: "",      // 回复内容
                status: 2,              // 状态（处理中/已处理）
                reply_img: []           // 回复图片
            }
        };
    },
    filters: {
        statusFilter(val) {
            return ["启用", "禁用"][+val];
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
        // 判断当前反馈是否处于处理中状态
        isProcessing() {
            return this.currentFeedback.status === '处理中';
        }
    },
    mounted() {
        this.getList();
        this.getOptions();
    },
    methods: {
        getOptions() {
            ssettingList({ page: 1, limit: 100000 })
                .then(res => {
                    this.options.type = res.list.filter(item => item.category_id === 14);
                })
                .catch(err => {
                    console.error('获取选项数据失败:', err);
                    this.$message.error('获取数据失败，请重试');
                });
        },
        getList(option) {
            if (option === "search") {
                this.page.page = 1;
            }
            
            const params = {
                ...this.search,
                page: this.page.page,
                page_size: this.page.limit,
                is_export: 0
            };
            
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });
            
            getFeedbackList(params)
                .then(res => {
                    this.list = res.data;
                    this.page.total = res.total;
                })
                .catch(err => {
                    console.error('获取列表失败:', err);
                    this.$message.error('获取数据失败，请重试');
                });
        },
  
        exportData() {
            const params = {
                ...this.search,
                page: this.page.page,
                page_size: this.page.limit,
                is_export: 1
            };
            
            getFeedbackList(params)
                .then(res => {
                    window.open(res.url);
                })
                .catch(err => {
                    console.error('导出失败:', err);
                    this.$message.error('导出失败，请重试');
                });
        },
        remoteMethod(keyword) {
            if (!keyword) {
                this.options.shop_list = [];
                return;
            }
            
            getShopList({ page: 1, limit: 100000, shopName: keyword })
                .then(res => {
                    this.options.shop_list = res.list || [];
                })
                .catch(err => {
                    console.error('搜索门店失败:', err);
                    this.$message.error('搜索门店失败');
                });
        },
        handleFeedback(row) {
            if (!row || !row.id) {
                this.$message.error('数据异常，无法处理');
                return;
            }
            
            this.currentFeedback = { ...row };
            this.dialogTitle = this.isProcessing ? "处理反馈" : "查看回复";
            
            if (this.isProcessing) {
                this.replyForm = {
                    id: row.id,
                    reply_content: "",
                    status: 2,
                    reply_img: []
                };
                this.replyImageList = [];
            }
            
            this.dialogVisible = true;
        },
        
        submitReply() {
            this.$refs.replyForm.validate(valid => {
                if (valid) {
                    this.replyForm.reply_img = this.replyImageList.map(file => file.url).join(',');
                    this.replyForm.reply_id = this.userInfo.id
                    
                    updateFeedback(this.replyForm)
                        .then(res => {
                            this.$message.success('回复成功');
                            this.dialogVisible = false;
                            this.getList(); // 刷新列表
                        })
                        .catch(err => {
                            console.error('提交回复失败:', err);
                            this.$message.error('回复失败，请重试');
                        });
                }
            });
        },
        
        handleImageUploadSuccess(response, file, fileList) {
            if (response && response.code === 200 && response.data && response.data.file_path) {
                file.url = response.data.file_path;
                this.replyImageList = fileList;
                this.$message.success('图片上传成功');
            } else {
                this.$message.error('图片上传失败：' + (response?.msg || '未知错误'));
            }
        },
        
        handleImageRemove(file, fileList) {
            this.replyImageList = fileList;
        },
        handleImageExceed(files, fileList) {
            this.$message.warning(`最多只能上传1张图片`);
        },
        
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('上传文件只能是图片格式!');
                return false;
            }
            
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            
            return true;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisibleImg = true;
        },
        handleSelectionChange(val) {
            this.idList = val.map(i => i.id);
        }
    }
};
</script>
  
<style lang="scss" scoped>
.mainColor {
    color: #2dc0a3;
}

.content {
    height: calc(100% - 56px);
    overflow-y: auto;
}

.bgW {
    background: #fff;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 20px;
}

.accountCon {
    background: #fff;
    padding: 0px 10px 80px;
    
    .btnBox {
        display: flex;
    }
}

.theme {
    cursor: pointer;
    margin-right: 10px;
}

.processing {
    color: #FF9800;
}

.resolved {
    color: #4CAF50;
}

.feedback-detail {
    .feedback-item {
        margin-bottom: 15px;
        display: flex;
        align-items: flex-start;
        
        .label {
            font-weight: bold;
            width: 80px;
            flex-shrink: 0;
        }
        .image-group {
            display: flex;
            flex-wrap: wrap;
            flex-grow: 1;
        }
    }
}

.resolved-content {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    background-color: #f5f7fa;
}

</style>
